module.exports = __webpack_public_path__ + "img/man-head-front.606e2c75.png";